/**
 * "Back to workspace", top centre above the wall (Part 05 Q3). It hides with
 * the rest of the focus chrome and comes back on hover or keyboard focus.
 */
import { Button, Icons } from "@/components/ui";
import { useFocusChromeAutoHide } from "@/components/layout/focus-chrome-autohide-store";
import {
  surfaceRoleAttributes,
  surfaceRoleClassName,
} from "@/components/ui/surface-contract";
import { useT } from "@/i18n";
import { framesSharedMessages } from "@/i18n/messages/frames-shared";
import { cn } from "@/lib/cn";
import { backToWorkspace } from "@/lib/focus/focus-back";
import { closeToCard } from "@/lib/focus/focus-card-return";

export function FocusBackPill({ frameId }: { frameId: string }) {
  const { focusChromeHidden, focusChromeRegionProps } =
    useFocusChromeAutoHide();
  const t = useT(framesSharedMessages);
  return (
    <div
      className="pointer-events-auto absolute left-1/2 top-appkit-lg z-30 -translate-x-1/2"
      data-interactive="true"
      {...focusChromeRegionProps}
    >
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={cn(
          surfaceRoleClassName("chrome"),
          "denker-focus-back-pill transition-opacity",
          focusChromeHidden && "opacity-0",
        )}
        {...surfaceRoleAttributes("chrome", {
          nativeLevel: "root",
          nativeGroup: "focus-back-pill",
        })}
        onClick={() => closeToCard(() => backToWorkspace(frameId))}
        data-testid="focus-back-pill"
      >
        <Icons.ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
        {t("backToWorkspace")}
      </Button>
    </div>
  );
}
